import * as React from "react";
import { joinClasses } from "../../..//utils/Filters";
import { ThemeVariants } from "../../../theme/_Types";
import { BaseConsumer } from "../03-base/Base";
import { FlexRow } from "../03-base/Flex/Row";
import { Logo } from "../03-base/Logo";
/**
 *
 * @param props
 */
export var FillUp = function (props) {
    var className = joinClasses("scl-h-filler", props.className);
    return (React.createElement(FlexRow, null,
        React.createElement(BaseConsumer, null, function (_a) {
            var _b;
            var getTheme = _a.getTheme;
            return (React.createElement("div", { className: className },
                props.children,
                React.createElement("div", { className: "scl-h-filler__logo" },
                    React.createElement(Logo, { variant: (_b = props.variant) !== null && _b !== void 0 ? _b : ThemeVariants.SHADED, theme: getTheme() }))));
        })));
};
